import { render } from "./Alert.vue?vue&type=template&id=8f24c8de"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"
script.render = render

export default script